import { darken, lighten, Theme } from '@mui/material'

import ESectionIds from '~/features/marketing/models'

const rem = (pixels: number) => `${pixels / 16}rem`

export function isColorLight(hex: string) {
  const hexCode = hex.replace('#', '')
  const r = parseInt(hexCode.substring(0, 2), 16)
  const g = parseInt(hexCode.substring(2, 4), 16)
  const b = parseInt(hexCode.substring(4, 6), 16)

  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255

  return luminance > 0.5
}

export function getWhiteOrBlackTextColorByBackground(
  background: string,
  theme: Theme,
) {
  return isColorLight(background)
    ? theme.palette.common.black
    : theme.palette.common.white
}

export function scrollToSection(id: ESectionIds, offset: number) {
  const targetSection = document.getElementById(id)
  if (targetSection) {
    const topOffset = targetSection.offsetTop - offset
    window.scrollTo({ top: topOffset, behavior: 'smooth' })
  }
}

export default rem

export function lightenOrDarken(color: string, percent: number = 0.2) {
  return isColorLight(color) ? darken(color, percent) : lighten(color, percent)
}
